import type { Etat } from '../../partage/api/types';

/**
 * Ce que produit un lien vers une bulle, selon son état (chantier `bugs`, ticket 02,
 * décisions d'Igor du 2026-10-01).
 *
 * Seules une bulle à faire ou en instruction retiennent celle qui l'attend. Acquise ou en
 * réflexion, elle ne retient rien aujourd'hui (moteur/dates, le tableau des états) : le lien
 * se pose quand même, il comptera si elle redevient à faire.
 */
export type CeQueProduitLeLien = 'retient' | 'deja_faite' | 'gardee_comme_idee';

export function ceQueProduitLeLien(etat: Etat): CeQueProduitLeLien {
  switch (etat) {
    case 'fait':
      return 'deja_faite';
    case 'sans_objet':
      return 'gardee_comme_idee';
    default:
      return 'retient';
  }
}
